import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface RemoveCancellationProps {
  accountId: string;
  goBack: () => void;
  onSuccess: () => void;
}

export default function RemoveCancellation({
  accountId,
  goBack,
  onSuccess,
}: RemoveCancellationProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { removeLicenseCancellation, isRemovingLicenseCancellation } =
    useLicenseMutations();

  function onClick() {
    removeLicenseCancellation({ accountId }).then(onSuccess);
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Remove scheduled cancellation?"
        subtitle="The seat for this account will renew on your next billing date. You can review your subscription at any time in your subscription settings."
      />
      <Footer className="justify-end">
        <Button
          onClick={goBack}
          variant="secondary-black"
          disabled={isRemovingLicenseCancellation}
        >
          Cancel
        </Button>
        <Button
          isLoading={isRemovingLicenseCancellation}
          onClick={onClick}
          variant="outline-danger"
        >
          Remove cancellation
        </Button>
      </Footer>
    </>
  );
}
